<template>
  <div :class="['loginBox', { isNew }, { forget: status === 5 }]">
    <div
      class="loginWay"
      v-if="!isNew"
      v-show="handleWay == 1 || handleWay == 2"
    >
      <div :class="{ active: handleWay == 1 }" @click="switchWay(1)">
        账户登录
      </div>
      <div :class="{ active: handleWay == 2 }" @click="switchWay(2)">
        短信登录
      </div>
    </div>
    <div v-if="handleWay == 3" class="register">注册账号</div>
    <div v-if="handleWay == 4 && !isNew" class="register">忘记密码</div>
    <el-form
      @keyup.enter.native="loginOrRegister"
      :model="accountMsg"
      ref="accountMsg"
      :rules="rules"
      class="formContainer"
      :validate-on-rule-change="false"
      :hide-required-asterisk="true"
    >
      <el-form-item
        v-if="handleWay == 1 || handleWay == 4"
        label="账号"
        prop="username"
      >
        <el-input
          v-model="accountMsg.username"
          maxlength="36"
          :placeholder="
            handleWay == 1
              ? '请输入手机号/用户名/邮箱'
              : '请输入注册的手机号码或邮箱地址'
          "
        ></el-input>
      </el-form-item>
      <el-form-item
        v-if="handleWay == 2 || handleWay == 3"
        label="手机号"
        prop="phone"
      >
        <el-input
          v-model.trim="accountMsg.phone"
          maxlength="11"
          @keyup.native="restrict('phone')"
          placeholder="请输入手机号"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item
        v-if="handleWay >= 2"
        label="验证码"
        prop="captcha"
        class="captcha"
      >
        <el-input
          maxlength="6"
          v-model.trim="accountMsg.captcha"
          @keyup.native="restrict('captcha')"
          placeholder="请输入验证码"
        >
          <el-button
            slot="suffix"
            @click="sendSMS"
            type="text"
            class="inputSuffix"
            :loading="timeRemaining == 60 && !allow"
            :disabled="!allow"
            >{{
              timeRemaining == 60 ? "获取验证码" : "重新获取" + timeRemaining
            }}</el-button
          >
        </el-input>
      </el-form-item>
      <el-form-item
        v-if="handleWay == 1 || handleWay == 3 || handleWay == 4"
        label="密码"
        prop="password"
      >
        <el-input
          minlength="6"
          maxlength="25"
          v-model="accountMsg.password"
          :type="isShowPsw ? 'text' : 'password'"
          placeholder="请输入您的密码"
        >
          <i
            slot="suffix"
            @click="isShowPsw = !isShowPsw"
            :class="[
              'iconfont',
              'showPsw',
              isShowPsw ? 'icon-a-kejianicon1x' : 'icon-a-bukejianicon1x',
            ]"
          ></i>
        </el-input>
      </el-form-item>
    </el-form>
    <p class="registerHint" v-if="handleWay == 3 || handleWay == 4">
      <!-- 混合使用字母、数字特殊符号组合(至少包含2种) -->
    </p>
    <div :class="['accountFunc', { accountFunc2: isNew }]" v-else>
      <el-button
        class="textBtn"
        type="text"
        v-if="status === 2"
        @click="switchWay(4)"
        >忘记密码{{ isNew ? "?" : "" }}</el-button
      >
      <el-button class="textBtn" v-if="!isNew" type="text" @click="switchWay(3)"
        >手机号注册</el-button
      >
    </div>
    <el-button
      type="primary"
      :class="['submitBtn', { submitBtn2: isNew }]"
      :loading="btnLoading"
      v-if="handleWay != 4"
      @click="loginOrRegister"
      :disabled="btnDisable"
      >{{
        handleWay == 3 ? "注册" : !isNew ? "登录" : butText[status]
      }}</el-button
    >
    <el-button
      type="primary"
      v-if="handleWay == 4"
      :class="['submitBtn', { submitBtn3: isNew }]"
      :loading="btnLoading"
      @click="loginOrRegister"
      >重置密码</el-button
    >
    <div v-if="!isNew">
      <div class="agreement" v-show="handleWay != 4">
        {{ handleWay == 3 ? "注册" : "点击登录" }}即同意我们的
        <a :href="userAgreement">《用户协议》</a>
        和
        <a :href="privacyAgreement">《隐私协议》</a>
      </div>
      <div class="otherLoginWay" v-if="handleWay == 1 || handleWay == 2">
        <el-divider>
          <span class="crossLine">其他登录方式</span>
        </el-divider>
        <div class="otherWay">
          <i class="iconfont icon-weixin" @click="otherLogin('weixin')"></i>
        </div>
      </div>
      <div class="hasAccount" v-else>
        已有账号？<el-button class="textBtn" type="text" @click="switchWay(1)"
          >去登录</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { getIP } from "../../../tool/index";
import { mapGetters, mapActions } from "vuex";
import {
  accountLogin,
  createSpace,
  phoneSignup,
  phontLogin,
  resetPsw,
  getBodyToToken,
  getIsOldUser,
  loginPhoneBinding,
} from "../../../api/accountManage";
import {
  setToken,
  phoneVerify,
  pswVerify,
  getCookieVal,
  removeToken,
} from "../../../tool";
// import { phoneVerify, pswVerify } from "../../../tool"
export default {
  props: {
    way: {
      type: Number,
      default: 1,
    },
    status: {
      type: Number,
      default: 1,
    },
    isNew: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      handleWay: 1, // 1 账号登录 2 短信登录 3 注册 4 忘记密码
      isShowPsw: false, // 是否显示密码
      accountMsg: {
        captcha: "",
      }, // 账号信息表单
      captchaType: 1, // 验证码类型
      btnLoading: false, // 登录/注册/重置密码loading
      butText: {
        2: "登录",
        3: "登录/注册",
        4: "绑定手机号",
      },
      wechatKey: null,
    };
  },
  created() {
    switch (this.$route.query.action) {
      case "register":
        this.handleWay = 3;
        break;
      case "forgetPsw":
        this.handleWay = 4;
        break;
      default:
        break;
    }
  },
  computed: {
    ...mapGetters([
      "userAgreement",
      "privacyAgreement",
      "allow",
      "timeRemaining",
      "captchaKey",
    ]),
    btnDisable() {
      if (this.handleWay === 1) {
        if (
          this.accountMsg.password?.length > 0 &&
          this.accountMsg.username?.length
        ) {
          return false;
        } else {
          return true;
        }
      } else if (this.handleWay === 2) {
        if (
          this.accountMsg.captcha?.length > 0 &&
          this.accountMsg.phone?.length > 0
        ) {
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    },
    // 表单验证
    rules() {
      let rule;
      switch (this.handleWay) {
        case 1: // 账号登录
          rule = {
            username: [
              {
                required: true,
                message: "请输入手机号/用户名/邮箱",
                trigger: "blur",
              },
            ],
            password: [
              { required: true, message: "请输入密码", trigger: "blur" },
            ],
          };
          break;
        case 2: // 短信登录
          rule = {
            phone: [{ validator: phoneVerify, trigger: "blur" }],
            captcha: [
              { required: true, message: "请输入验证码", trigger: "blur" },
            ],
          };
          break;
        case 3: // 注册
          rule = {
            phone: [{ validator: phoneVerify, trigger: "blur" }],
            captcha: [
              { required: true, message: "请输入验证码", trigger: "blur" },
            ],
            password: [{ validator: pswVerify, trigger: "blur" }],
          };
          break;
        case 4: // 重置密码
          rule = {
            username: [
              { required: true, message: "请输入手机号/邮箱", trigger: "blur" },
            ],
            captcha: [
              { required: true, message: "请输入验证码", trigger: "blur" },
            ],
            password: [{ validator: pswVerify, trigger: "blur" }],
          };
          break;
      }
      return rule;
    },
  },
  watch: {
    way(val) {
      if (val) {
        this.handleWay = val;
      }
    },
    // 账号表单
    handleWay: {
      handler(val) {
        this.$store.commit("RESET_SMS");
        let form;
        let phone = this.accountMsg.phone;
        let username;
        let reg =
          /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
        if (reg.test(this.accountMsg.username)) {
          username = this.accountMsg.username;
        }
        switch (val) {
          case 1: // 账号登录
            form = {
              username: phone || username, // 账号
              password: null, // 密码
              platformType: 1, // 平台类型
              clientType: this.$route.query.from ? 3 : 1, // 客户端类型
            };
            document.title = "爱原物-登录";
            break;
          case 2: // 短信登录
            form = {
              phone: phone || username, // 账号
              captcha: null, // 验证码
              platformType: 1,
              clientType: this.$route.query.from ? 3 : 1,
            };
            this.captchaType = 1;
            document.title = "爱原物-登录";
            break;
          case 3: // 注册
            form = {
              phone: phone || username,
              market: this.$route.query.market || 0, // 0 不区分 1 内销 2 外销
              captcha: null,
              password: null,
              ip: getIP(), // IP地址
              registerSource: 1, // 1:PC 2:android 3:ios 4:h5
              registerFrom: getCookieVal("registerFrom"), // 推广活动来源
              searchEngine: getCookieVal("searchEngine"), // 搜索引擎来源
              sourceType: this.$route.query.from ? 1 : 3, // 1:caihong 2:iywutu 3:saas
              captchaKey: null,
              isLogin: 1, // 是否直接登录 1 是 0 否
            };
            this.captchaType = 4;
            document.title = "爱原物-注册";
            break;
          case 4: // 修改密码
            form = {
              username: phone || username,
              captcha: null,
              password: null,
              captchaKey: null,
            };
            this.captchaType = 3;
            document.title = "爱原物";
            break;
        }
        form.deviceType = 1; // 1pc,2h5,3app,4小程序，5未知设备
        this.$set(this.$data, "accountMsg", form);
        if (this.$refs["accountMsg"]) {
          this.$refs["accountMsg"].resetFields();
        }
      },
      immediate: true,
    },
    captchaKey(val) {
      this.accountMsg.captchaKey = val;
    },
  },
  methods: {
    ...mapActions(["getCaptcha", "ProductToken"]),
    restrict(type) {
      switch (type) {
        case "captcha":
          if (this.accountMsg.captcha) {
            this.accountMsg.captcha = this.accountMsg.captcha.replace(
              /\D/g,
              ""
            );
          }
          break;
        case "phone":
          if (this.accountMsg.phone) {
            this.accountMsg.phone = this.accountMsg.phone.replace(/\D/g, "");
          }
          break;
      }
    },
    // 切换登录方式/注册
    switchWay(way) {
      this.handleWay = way;
      this.btnLoading = false;
      if (this.isNew && way === 4) {
        this.$emit("setStatus", 5); // 改变父组件标题
      }
    },
    // 获取验证码
    async sendSMS() {
      let key;
      if (this.handleWay === 4) {
        key = "username";
      } else {
        key = "phone";
      }
      this.$refs["accountMsg"].validateField(key, async (err) => {
        if (!err) {
          let params = {
            type: this.captchaType,
            phone: this.accountMsg.phone || this.accountMsg.username,
          };
          let { data } = await this.getCaptcha(params);
          if (data) {
            this.accountMsg.captchaKey = data.captchaKey;
          }
        }
      });
    },
    // 其他登录方式
    otherLogin(way) {
      this.$emit("otherLogin", way);
      this.btnLoading = false;
      if (way === "weixin") {
        // 微信登录日志
        window.log.singleLog("clickWeixinLogin");
      }
    },
    // 登录或注册提交
    async loginOrRegister() {
      this.$refs["accountMsg"].validate((valid) => {
        if (valid) {
          this.btnLoading = true;
          switch (this.handleWay) {
            case 1: // 账号登陆
              this.accountLogin();
              break;
            case 2: // 短信登陆
              this.phontLogin();
              break;
            case 3: // 注册
              this.register();
              break;
            case 4: // 重置密码
              this.resetPsw();
              break;
          }
        }
      });
    },
    // 账号登陆
    async accountLogin() {
      let res = await accountLogin(this.accountMsg).catch(() => {
        this.btnLoading = false;
      });
      if (res) {
        this.loginInfoDispose(res, true);
      }
    },
    // 短信登陆-=3 / 绑定手机号码=4
    async phontLogin() {
      let obj = this.accountMsg;
      let api = phontLogin;
      if (this.status === 4) {
        api = loginPhoneBinding;
        obj = {
          phone: this.accountMsg.phone,
          captcha: this.accountMsg.captcha,
          captchaKey: this.accountMsg.captchaKey,
          clientType: 1,
          deviceType: 1,
          wechatKey: this.wechatKey,
        };
      }
      let res = await api(obj).catch(() => {
        this.btnLoading = false;
      });
      if (res) {
        this.loginInfoDispose(res, true);
      }
      this.btnLoading = false;
    },
    // 账号注册
    async register() {
      let res = await phoneSignup(this.accountMsg).catch(() => {
        this.btnLoading = false;
      });
      if (res.code === 1) {
        this.handleWay = 1;
        if (this.accountMsg.isLogin === 1) {
          this.$message({
            type: "success",
            message: "注册成功",
          });
          // 注册成功后必选身份
          this.$emit("selectIdentity", res.data);
        }
      }
      this.btnLoading = false;
    },
    // 重置密码
    async resetPsw() {
      let res = await resetPsw(this.accountMsg).catch(() => {
        this.btnLoading = false;
      });
      if (res.code === 1) {
        this.$message({
          type: "success",
          message: "重置密码成功",
        });
        this.handleWay = 1;
        this.$emit("setStatus", 2); // 切换账号密码登录
      }
      this.btnLoading = false;
    },
    // 登录跳转统一处理
    async loginInfoDispose(res, bool) {
      removeToken(); // 删除token
      let data = null;
      switch (res.code) {
        case 1: // 默认主体
          // if (process.env.NODE_ENV !== 'tests') {
          // }
          this.$store.commit("SET_TOKEN", res.data.token.accessToken);
          // 是否选择意向 1已选择 0未选择
          if (bool && res.data.selectIntent === 0) {
            this.$emit("selectIntent", res.data);
            return;
          }
          if (bool) {
            this.btnLoading = true;
            data = await getIsOldUser().catch(() => {
              this.btnLoading = false;
            }); // 判断是否是老用户
            if (data && data.code === 1 && data.data?.isOldUser) {
              // true:老用户，false：非老用户
              this.$emit("isOldUserFun", res.data);
              return;
            }
            this.btnLoading = false;
          }
          await this.ProductToken(); // 获取供应链token
          setToken("iyuanwu_token", res.data.token.accessToken);
          setToken("iyuanwu_refreshToken", res.data.token.refreshToken);
          setToken(
            "iyuanwu_expiration",
            Date.parse(new Date()) + res.data.token.expiration * 1000
          );
          // 图案网嵌套登录
          if (this.$route.query?.clientType === "IYW") {
            window.top.postMessage(
              {
                type: "login",
                iyuanwu_token: res.data.token.accessToken,
                iyuanwu_refreshToken: res.data.token.refreshToken,
                iyuanwu_expiration: res.data.token.expiration,
              },
              "*"
            );
            this.$emit("closeDialog");
            return;
          }
          this.judgeFrom(res); // 其他网站跳转过来登录处理
          break;
        case 410: // 选择主体
          this.$store.commit("SET_TOKEN", res.data.token.accessToken);
          this.$emit("selectBody", res.data.userId, res.data.sessionKey);
          break;
        case 409: // 没有主体
          this.bodyHandle("noBody", res.data);
          break;
        case 411: // 主体被删除
          this.bodyHandle("beDel", res.data);
          break;
        case 412: // 被主体停用
          this.bodyHandle("beStopped", res.data);
          break;
      }
    },
    // 没有主体/被删除/被停用操作
    bodyHandle(type, data) {
      let hintMsg;
      switch (type) {
        case "noBody": // 没有主体
          hintMsg = "您当前没有主体请创建主体";
          break;
        case "beDel": // 被删除
          hintMsg = "您尚未加入任何企业，请联系您企业的管理员";
          break;
        case "beStopped": // 被停用
          hintMsg = "您的账号已被所在企业管理员停用，请联系您企业的管理员";
          break;
        case "selectBody": // 选择主体
          this.$emit("selectBody", data.userId, data.sessionKey);
          return;
      }
      this.$confirm(hintMsg, "提示", {
        distinguishCancelAndClose: true,
        confirmButtonText: "创建个人空间",
        cancelButtonText: "我知道了",
      })
        .then(async () => {
          let res = await createSpace({ userId: data.userId });
          if (res.code === 1) {
            // 创建主体后直接重新获取token登录
            getBodyToToken({
              userId: data.userId,
              caihongId: res.data.caihongNo,
              employName: res.data.employName,
              sessionKey: data.sessionKey,
              orgCode: res.data.orgCode,
              employeeId: res.data.employeeId,
              platformType: 1,
              clientType: 1,
              orgFlag: res.data.orgFlag,
            }).then((res) => {
              if (res.data) {
                if (process.env.NODE_ENV === "development") {
                  setToken("iyuanwu_token", res.data.accessToken);
                  setToken("iyuanwu_refreshToken", res.data.refreshToken);
                  setToken(
                    "iyuanwu_expiration",
                    Date.parse(new Date()) + res.data.expiration * 1000
                  );
                  this.$store.dispatch("goIndex");
                } else {
                  window.location.href = `${process.env.VUE_APP_API}/sso/api/sso/web/silent?clientType=SAAS&refreshToken=${res.data.refreshToken}&callBackUrl=${process.env.VUE_APP_INDEX_URL}`;
                }
              }
            });
          }
        })
        .catch(() => {});
    },
    judgeFrom(res) {
      let url = this.$route.hash
        ? this.$route.query.callBackUrl + this.$route.hash
        : this.$route.query.callBackUrl;
      switch (
        this.$route.query.from // 其他网站跳转过来登录处理
      ) {
        case "caihong":
          if (process.env.NODE_ENV === "development") {
            window.location.href =
              this.$route.query.to || process.env.VUE_APP_CAIHONG_URL;
          } else {
            let url = this.$route.query.to || process.env.VUE_APP_CAIHONG_URL;
            // window.location.href = `${process.env.VUE_APP_API}/sso/api/sso/web/silent?clientType=CAIHONG&refreshToken=${res.data.token.refreshToken}&callBackUrl=${process.env.VUE_APP_CAIHONG_URL}`
            window.location.href = `${process.env.VUE_APP_API}/sso/api/sso/web/silent?clientType=CAIHONG&refreshToken=${res.data.token.refreshToken}&callBackUrl=${url}`;
          }
          break;
        case "portal": // 落地页
          // if (process.env.NODE_ENV === "development") {
          window.location.href = url || process.env.VUE_APP_PORTAL;
          // } else {
          //   window.location.href = `${process.env.VUE_APP_API}/sso/api/sso/web/silent?clientType=PORTAL&refreshToken=${res.data.token.refreshToken}&callBackUrl=${this.$route.query.callBackUrl}`;
          // }
          break;
        case "ai": // 生成ai
          window.location.href = url || process.env.VUE_APP_AI;
          break;
        case "aiChdesign": // ai设计平台
          window.location.href = `${process.env.VUE_APP_API}/sso/api/sso/web/silent?clientType=OTHER&refreshToken=${res.data.token.refreshToken}&callBackUrl=${process.env.VUE_APP_AI_CHDESIGN}`;
          break;
        default:
          if (process.env.NODE_ENV === "development") {
            this.$store.dispatch("goIndex");
          } else {
            window.location.href = `${process.env.VUE_APP_API}/sso/api/sso/web/silent?clientType=SAAS&refreshToken=${res.data.token.refreshToken}&callBackUrl=${process.env.VUE_APP_INDEX_URL}`;
          }
          break;
      }
    },
  },
};
</script>

<style lang="scss">
.loginBox {
  width: 474px;
  // height: 608px;
  padding: 40px 63px;
  background: #ffffff;
  box-shadow: 1px 13px 32px 0px rgba(0, 0, 0, 0.09);
  border-radius: 4px;
  .textBtn {
    padding: 0;
  }
  .loginWay {
    font-size: 18px;
    display: flex;
    justify-content: center;
    color: #b3b9c7;
    transition: all 0.3s;
    margin-bottom: 22px;
    & > div {
      position: relative;
      padding-bottom: 16px;
      margin: 0 31px;
      cursor: pointer;
      &::after {
        position: absolute;
        content: "";
        left: 0;
        bottom: 0;
        display: inline-block;
        background: $primaryColor;
        width: 0%;
        height: 2px;
        border-radius: 1px;
        transition: all 0.3s;
      }
      &.active {
        color: $primaryColor;
        &::after {
          width: 100%;
        }
      }
    }
  }
  .register {
    text-align: center;
    font-size: 24px;
    font-weight: 600;
  }
  .formContainer {
    .el-input {
      input {
        height: 48px;
      }
    }
    .showPsw {
      padding-right: 16px;
      line-height: 48px;
      cursor: pointer;
    }
  }
  .registerHint {
    padding-top: 10px;
    font-size: 12px;
    color: $gray;
  }
  .accountFunc {
    display: flex;
    justify-content: space-between;
  }
  .accountFunc2 {
    justify-content: flex-end;
    .el-button {
      color: #999;
      font-size: 12px;
    }
  }
  .submitBtn3 {
    margin-bottom: 20px;
  }
  .submitBtn {
    font-size: 18px;
    width: 100%;
    margin-top: 32px;
    padding: 16px 20px;
  }
  .submitBtn2 {
    margin: 27px 0 29px;
    padding: 13px 20px;
  }
  .agreement {
    text-align: center;
    font-size: 13px;
    margin-top: 25px;
    padding-bottom: 6px;
    a {
      color: $primaryColor;
    }
  }
  .otherLoginWay {
    .crossLine {
      color: $grayColor;
      font-size: 12px;
    }
    .otherWay {
      text-align: center;
      i {
        cursor: pointer;
        color: #00c800;
        font-size: 38px;
      }
    }
  }
  .hasAccount {
    margin-top: 22px;
    text-align: center;
  }
}
.isNew {
  width: 100%;
  padding: 0 88px;
  box-shadow: none;
  border-radius: 0;
  .el-form {
    margin-top: 28px;
    .captcha {
      margin-bottom: 8px;
    }
    .el-form-item {
      &:last-child {
        margin-bottom: 8px;
      }
    }
    .el-form-item__label {
      font-size: 14px;
      font-weight: 400;
      color: #222222;
      line-height: 20px;
      margin-bottom: 12px;
    }
  }
}
.forget {
  .formContainer {
    margin-top: 20px;
    .el-form-item {
      margin-bottom: 14px;
      .el-form-item__label {
        margin-bottom: 12px;
      }
      .el-input input {
        height: 46px;
      }
      &:last-child {
        margin-bottom: 14px;
      }
    }
  }
  .registerHint {
    padding: 0;
    line-height: 17px;
  }
  .submitBtn3 {
    margin-top: 24px;
    padding: 13px 20px;
  }
}
</style>
